export namespace TeaProperties {
  export type TypeEnum = 'GREEN' | 'BLACK' | 'WHITE' | 'FRUIT' | 'OTHER';
  export const TypeEnum = {
    Green: 'GREEN' as TypeEnum,
    Black: 'BLACK' as TypeEnum,
    White: 'WHITE' as TypeEnum,
    Fruit: 'FRUIT' as TypeEnum,
    Other: 'OTHER' as TypeEnum,
  };
  export type PreparationProcedureEnum =
    | 'FERMENTED'
    | 'NOT_FERMENTED'
    | 'EXTRACT_ESSENCE_CONCENTRATE'
    | 'BASED_ON_EXTRACT_ESSENCE_CONCENTRATE';
  export const PreparationProcedureEnum = {
    Fermented: 'FERMENTED' as PreparationProcedureEnum,
    NotFermented: 'NOT_FERMENTED' as PreparationProcedureEnum,
    ExtractEssenceConcentrate:
      'EXTRACT_ESSENCE_CONCENTRATE' as PreparationProcedureEnum,
    BasedOnExtractEssenceConcentrate:
      'BASED_ON_EXTRACT_ESSENCE_CONCENTRATE' as PreparationProcedureEnum,
  };
  export type FormatEnum = 'FIBROUS' | 'FILTER' | 'INSTANT';
  export const FormatEnum = {
    Fibrous: 'FIBROUS' as FormatEnum,
    Filter: 'FILTER' as FormatEnum,
    Instant: 'INSTANT' as FormatEnum,
  };
}
